import styles from './email-list.module.scss';
import { useGetRequestNewHook } from '../requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import { useNavigate } from 'react-router-dom';
import { CreateHeaders, HeaderSizeEnum, PrimaryButton, dateHeader, textHeader, Icon } from '@frontend-workspace/react-shared-lib';
import WebkuaTable from '../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailListProps { }

export function EmailList(props: EmailListProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useGetRequestNewHook(`admin/emails`, []);

  const editTemplateRenderer = (params: ValueFormatterParams) => {
    const navigateToTemplate = () => { navigate(`${params.data.templateId}`) };
    return (
      <PrimaryButton
        variant="outlined"
        size='small'
        onClick={navigateToTemplate}>
        {t("standard.change")}
      </PrimaryButton>
    );
  };

  const daysAfterEventRenderer = (params: ValueFormatterParams) => {
    if (params.data.isOrder) return t("emailList.immediately");
    if (!params.data.daysAfterEvent) return t("emailList.noTrigger");
    return params.data.daysAfterEvent + " " + t("standard.days");
  };

  const headers = CreateHeaders([
    textHeader("templateName", t("standard.name")),
    textHeader("subject", t("standard.emailSubject")),
    dateHeader("updatedAt", t("standard.lastChanged")),
    textHeader("eventName", t("emailList.triggerEvent")),
    textHeader("daysAfterEvent", t("emailList.daysAfterEvent"), HeaderSizeEnum.SMALL, { renderer: daysAfterEventRenderer }),
    textHeader("triggerDescription", t("standard.triggerDescription"), HeaderSizeEnum.LARGE),
    textHeader("triggerLanguage", t("standard.language"), HeaderSizeEnum.SMALL),
    textHeader("", "", HeaderSizeEnum.MEDIUM, {
      renderer: editTemplateRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    })
  ])

  return <>
    <PrimaryButton
      variant='contained'
      onClick={() => navigate('new')}
      className='minButtonWidth'>
      <Icon className="me-1" fontSize="small">add</Icon>{t("standard.newEmail")}
    </PrimaryButton>
    <WebkuaTable
      headers={headers}
      data={data}
    />
  </>;
}

export default EmailList;